import request from '@/utils/request'
import { getToken } from '../utils/auth'
// 新建项目
export function addproject (data) {
  return request({
    url: '/addproject',
    method: 'post',
    params: { token: getToken() },
    data
  })
}
// 更新项目
export function updateproject (data) {
  return request({
    url: '/updateproject',
    method: 'post',
    params: { token: getToken() },
    data
  })
}
// 删除项目
export function deleteproject (data) {
  return request({
    url: '/deleteproject',
    method: 'post',
    params: { token: getToken() },
    data
  })
}
// 查询套餐
export function minigoodsList () {
  return request({
    url: '/minigoods/list',
    method: 'post',
    params: { token: getToken() }
  })
}
// 新增套餐
export function minigoodsAdd (data) {
  return request({
    url: '/minigoods/add',
    method: 'post',
    params: { token: getToken() },
    data
  })
}
// 更新套餐
export function minigoodsUpdate (data) {
  return request({
    url: '/minigoods/update',
    method: 'post',
    params: { token: getToken() },
    data
  })
}
// 删除套餐
export function minigoodsDelete (data) {
  return request({
    url: '/minigoods/delete',
    method: 'post',
    params: { token: getToken() },
    data
  })
}
// queryminiinvite
export function queryminiinvite (data) {
  return request({
    url: '/queryminiinvite',
    method: 'post',
    params: { token: getToken() },
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/project.js